/**
 * O menu que o servidor decide (`T-21`, ADR-085): os endereços das áreas que a pessoa alcança —
 * pela licença da organização, pelo perfil dela e pelo que o contrato de cada concessão do
 * recorte tem.
 *
 * `null` enquanto carrega **e** quando o servidor não respondeu: quem usa cai na conta antiga
 * (`areasVisiveis`, de licença e perfil), sem as áreas do contrato. Falhar aqui não pode
 * esvaziar o menu — uma rede instável deixaria o operador sem navegação, sem nada na tela
 * explicando por quê —, e quem recusa o que não devia aparecer continua sendo o servidor.
 */
import { useEffect, useState } from "react";

import { api } from "../api/cliente";
import type { Navegacao } from "../api/tipos";

export function useNavegacao(): {
  codigos: string[] | null;
  carregando: boolean;
} {
  const [codigos, definirCodigos] = useState<string[] | null>(null);
  const [carregando, definirCarregando] = useState(true);

  useEffect(() => {
    let vivo = true;
    void api<Navegacao>("/navegacao")
      .then((navegacao) => {
        if (vivo) definirCodigos(navegacao.areas.map((a) => a.codigo));
      })
      .catch(() => {
        if (vivo) definirCodigos(null);
      })
      .finally(() => {
        if (vivo) definirCarregando(false);
      });
    return () => {
      vivo = false;
    };
  }, []);

  return { codigos, carregando };
}
